import { testimonials } from '@/mocks/testimonials';
import type { Testimonial } from '@/mocks/testimonials';

function TextCard({ item }: { item: Testimonial }) {
  return (
    <div className="bg-background-100 rounded-2xl p-6 flex flex-col h-full">
      <div className="flex items-center gap-3 mb-4">
        <img
          src={item.avatar}
          alt={item.name}
          className="w-10 h-10 rounded-full object-cover"
          loading="lazy"
        />
        <div>
          <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
          <p className="text-xs text-foreground-500">{item.role}</p>
        </div>
      </div>
      <div className="flex-1">
        <div className="w-6 h-6 flex items-center justify-center mb-3">
          <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
        </div>
        <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
      </div>
      <div className="flex items-center gap-0.5 mt-4">
        {Array.from({ length: item.rating }).map((_, i) => (
          <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-xs text-accent-500"></i>
          </div>
        ))}
      </div>
    </div>
  );
}

function ImageCard({ item }: { item: Testimonial }) {
  return (
    <div className="relative rounded-2xl overflow-hidden h-full min-h-[280px] group">
      <img
        src={item.image}
        alt={item.name}
        className="w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-900/80 via-primary-900/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <p className="text-sm text-background-50/90 leading-relaxed line-clamp-3">{item.content}</p>
        <div className="flex items-center gap-2 mt-3">
          <img
            src={item.avatar}
            alt={item.name}
            className="w-8 h-8 rounded-full object-cover"
            loading="lazy"
          />
          <div>
            <p className="text-sm font-semibold text-background-50">{item.name}</p>
            <p className="text-xs text-background-50/60">{item.role}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const t0 = testimonials[0];
  const t1 = testimonials[1];
  const t2 = testimonials[2];
  const t3 = testimonials[3];
  const t4 = testimonials[4];

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="w-5 h-5 flex items-center justify-center mx-auto mb-3">
            <i className="ri-shield-star-line text-xl text-primary-500"></i>
          </div>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">
            读者口碑
          </span>
          <h2 className="mt-2 text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            万千读者的信赖之选
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <TextCard item={t0} />

          <TextCard item={t1} />

          <ImageCard item={t2} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
          <div className="md:col-span-2">
            <ImageCard item={t3} />
          </div>

          <TextCard item={t4} />
        </div>
      </div>
    </section>
  );
}